module.exports = "/images/role-other-icon.svg?9746d893b6e5c1da20701443397573e7";